import { Iterable, IPlace } from "types";

type Availability = "YES" | "NO" | "UNDEFINED";

export const isAvailableForRouting = (
  place?: Iterable<IPlace> | IPlace
): Availability => {
  if (place?.available_for_route === true) {
    return "YES";
  }

  if (place?.available_for_route === undefined) {
    return "UNDEFINED";
  }

  if (place.replacement_coordinates) {
    return "YES";
  }

  return "NO";
};
